/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aitexteventpromptlabel4Inputs */

const en_aitexteventpromptlabel4 = /** @type {(inputs: Aitexteventpromptlabel4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the event about?`)
};

const de_aitexteventpromptlabel4 = /** @type {(inputs: Aitexteventpromptlabel4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Worum geht es bei dem Event?`)
};

/**
* | output |
* | --- |
* | "What is the event about?" |
*
* @param {Aitexteventpromptlabel4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aitexteventpromptlabel4 = /** @type {((inputs?: Aitexteventpromptlabel4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aitexteventpromptlabel4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aitexteventpromptlabel4(inputs)
	return de_aitexteventpromptlabel4(inputs)
});
export { aitexteventpromptlabel4 as "aiTextEventPromptLabel" }